import { useHasSelectedDispensaryToView, useHasAssignedDispensaryToCart } from 'shop/hooks/use-has-set-dispensary';

import { useMarketplaceCategoryLinks } from './use-marketplace-category-links';
import { useMarketplaceDispensaryCategoryLinks } from './use-marketplace-dispensary-category-links';

import { UseCategoryLinksReturn } from './use-category-links.types';

export function useCategoryLinks(): UseCategoryLinksReturn {
  const hasSelectedDispensaryToView = useHasSelectedDispensaryToView();
  const hasAssignedDispensaryToCart = useHasAssignedDispensaryToCart();

  const marketplaceCategoryLinks = useMarketplaceCategoryLinks();
  const marketplaceDispensaryCategoryLinks = useMarketplaceDispensaryCategoryLinks();

  return hasSelectedDispensaryToView || hasAssignedDispensaryToCart
    ? marketplaceDispensaryCategoryLinks
    : marketplaceCategoryLinks;
}
